import type { AuthUser } from '../services/authApi';
import type { GalleryPurchase, GallerySearch } from '../services/userApi';

/** Vista previa del dashboard sin login (solo local: REACT_APP_ACCOUNT_PREVIEW=true). */
export const ACCOUNT_PREVIEW = process.env.REACT_APP_ACCOUNT_PREVIEW === 'true';

export const PREVIEW_USER: AuthUser = {
  id: 'preview-user-id',
  email: 'stefaniabelloni92@gmail.com',
  display_name: 'Stefania Belloni',
  auth_provider: 'email',
  email_verified: true,
  has_avatar: false,
};

export const PREVIEW_GALLERY: {
  purchases: GalleryPurchase[];
  searches: GallerySearch[];
} = {
  purchases: [
    {
      id: 'PAY_preview_zoopark',
      amount: 35,
      currency: 'eur',
      created_at: new Date().toISOString(),
      items_count: 54,
      can_download_any: true,
      active_items_count: 54,
    },
  ],
  searches: [
    {
      id: 'search-preview-1',
      school: 'ZOOPARK',
      session_date: '2026-05-31',
      match_count: 12,
      match_filenames: [
        'DSC_0001.jpg',
        'DSC_0002.jpg',
        'DSC_0003.jpg',
        'DSC_0004.jpg',
        'DSC_0005.jpg',
        'DSC_0006.jpg',
      ],
    },
  ],
};
